import { render, staticRenderFns } from "./Aircrafts.vue?vue&type=template&id=52d7c2b0&"
import script from "./Aircrafts.vue?vue&type=script&lang=js&"
export * from "./Aircrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports